import { useGetUserQuestionsQuery } from "./userQuestionApiSlice"
import UserQuestion from "./UserQuestion"
import useAuth from "../../hooks/useAuth"
import PulseLoader from 'react-spinners/PulseLoader'
import { faAdd } from "@fortawesome/free-solid-svg-icons"
import { Link, useParams } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
const UserQuestionList = ({ q}) => {
    const {groupId} = useParams()
    const {  isTeacher, isAdmin } = useAuth()
    const {
        data: userQuestions,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetUserQuestionsQuery('userQuestionList', {
        // pollingInterval: 15000,
        // refetchOnFocus: true,
        refetchOnMountOrArgChange: false
    })




    let content

    if (isLoading) content = <PulseLoader color={"#FFF"} />

    if (isError) {
        content = <p className="errmsg">{error?.data?.message}</p>
    }

    if (isSuccess ) {
        const { ids, entities } = userQuestions
       
        let filteredIds = []
        if(groupId !== '0'||  q!==''){
            filteredIds=[...ids].filter(userQuestionsId =>{
                const userQuestion=  entities[userQuestionsId]
             return (
                   (q==='' ||(userQuestion.questionSetTitle.indexOf(q) >-1))
                   && (groupId ==='0' ||  userQuestion.group?._id=== groupId)
                   )

            })
        }else
            {
                filteredIds = [...ids]
            }

        

        const tableContent = ids?.length && filteredIds.map(userQuestionId => <UserQuestion key={userQuestionId} userQuestionId={userQuestionId} />)

        content = (
            <>
            <table className={`table table--userQuestions ${(isAdmin || isTeacher)&& "table--userQuestions--admin"} `}>
                <thead className="table__thead">
                    <tr>
                        <th scope="col" className="table__th userQuestion__title">שאלון</th>
                        <th scope="col" className="table__th userQuestion__body">משתמש</th>
                        <th scope="col" className="table__th userQuestion__actions"> מתאריך</th>
                        <th scope="col" className="table__th userQuestion__actions"> עד תאריך</th>
                        <th scope="col" className="table__th userQuestion__dates"> בוצע </th>

                        <th scope="col" className="table__th userQuestion__actions"> ציון</th>
                        <th scope="col" className="table__th userQuestion__edit">#</th>
                    </tr>
                </thead>
                <tbody>
                    {tableContent}
                </tbody>
            </table>
            </>
        )
    }

    return content
}
export default UserQuestionList